var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-auth"},[_c('div',{staticClass:"background-shapes-top"}),_c('div',{staticClass:"background-shapes-bottom"}),_c('div',{staticClass:"content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }